<template>
    <div>
        <v-container class="global-margin">
            <v-breadcrumbs :items="breadcrumbs" class="breadcrumbs pl-0" large></v-breadcrumbs>
        </v-container>
        <v-container fluid>
            <v-container class="sumtv-content">
                <v-row class="flex-top w-100">
                    <v-col cols="12" md="8" id="player" class="flex-center flex-column">
                        <v-text-field
                                label="Pretraži videoteku"
                                clearable
                                outlined
                                v-model="searchClient"
                                @input="handleSearchInput"
                                class="w-100 mx-3"
                        ></v-text-field>
                        <div v-if="!currentVideo" class="sum-placeholder w-100 flex-center flex-column text-center pa-5">
                            <template v-if="loading">
                                <v-progress-circular indeterminate color="#094776" class="mb-4"></v-progress-circular>
                                <p class="text--secondary mb-0">Učitavanje videoteke...</p>
                            </template>
                            <template v-else-if="videoList.length !== 0">
                                <i class="fas fa-play-circle fa-4x mb-4 placeholder-icon"></i>
                                <h2 class="text--primary font-weight-bold mb-2">Odaberite video</h2>
                                <p class="text--secondary mb-0">Kliknite na lekciju iz videoteke za pokretanje videa.</p>
                            </template>
                            <template v-else>
                                <i class="fas fa-video-slash fa-4x mb-4 placeholder-icon"></i>
                                <p class="text--secondary mb-0">Trenutno nema dostupnih videa.</p>
                            </template>
                        </div>
                        <div v-else class="w-100">
                            <iframe class="sumtv-iframe"
                                    :src="getEronetEmbed(currentVideo.file_path)"
                                    frameborder="0" scrolling="no" allowFullScreen>
                            </iframe>
                            <h1 v-if="currentVideo.parent" class="text--primary font-weight-bold mt-2 w-100">{{currentVideo.parent.title}}</h1>
                            <p v-if="currentVideo.parent" class="text--disable mt-2 w-100">{{ currentVideo.content_date | moment("D.M.YYYY.") }}</p>
                        </div>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-row class="flex-top">
                            <v-col cols="6" class="pt-0">
                                <v-select
                                        clearable
                                        v-model="classClient"
                                        outlined
                                        :items="classes"
                                        item-text="title"
                                        item-value="id"
                                        label="Razred"
                                        @input="getVideos"
                                ></v-select>
                            </v-col>
                            <v-col cols="6" class="pt-0">
                                <v-menu
                                        ref="menu"
                                        v-model="menu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                                clearable
                                                @click:clear="selectedDate = null; getVideos();"
                                                v-model="selectedDate"
                                                label="Datum"
                                                outlined
                                                readonly
                                                v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                            v-model="dateClient"
                                            @input="handlePickedDate"
                                            no-title scrollable>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>

                        </v-row>
                        <div class="videoteka w-100">
                            <template v-if="chunkedVideos && chunkedVideos.length !== 0">
                                <div v-for="(vid, index) in chunkedVideos"
                                     class="pa-7 mb-5 videoteka-item flex-between"
                                     @click="playVideo(vid)"
                                     :key="'videoteka' + index">
                                    <div class="vid-title d-flex flex-column">
                                        <h4 class="font-weight-medium text--secondary">{{vid.school_class.grade}}. Razred - {{vid.course.title}}</h4>
                                        <h2 class="text--primary font-weight-bold" v-if="vid.lesson">{{vid.lesson.title}}</h2>
                                        <p class="text--disabled mb-0">{{vid.content_date | moment("D.M.YYYY.")}}</p>
                                    </div>
                                    <i class="fas fa-play ml-3 fa-2x text--disabled"></i>
                                </div>
                            </template>
                            <p v-else-if="loading" class="mt-3 w-100 text-center text--secondary">Učitavanje...</p>
                            <v-alert v-else type="error" class="alert" border="left">
                                Nema sadržaja
                            </v-alert>
                            <v-btn v-if="videoList.length > videoCount * 10" class="show-more text-capitalize" @click="videoCount++" outlined color="#094776">Učitaj još</v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
    </div>
</template>

<script>
    import Flickity from 'vue-flickity';

    export default {
        components: {
            Flickity
        },
        data() {
            return {
                currentVideo: null,
                videoList: [],
                videoCount: 1,
                dateClient: null,
                rawClasses: [],
                classes: [],
                menu: false,
                modal: false,
                loading: true,
                classClient: '',
                searchClient: '',
                selectedDate: null,
                search: null,
                breadcrumbs: [{
                    text: 'Naslovnica',
                    disabled: false,
                    to: '/'
                },
                    {
                        text: 'SUM TV',
                        disabled: true,
                    },
                ],
            }
        },
        computed: {
          chunkedVideos() {
              return this.videoList.slice(0, 10 * this.videoCount);
          }
        },
        created() {
            this.getVideos();
            var self = this;
            setInterval(function () {
                this.loading = true;
                self.getVideos();
            }, 60 * 1000);
            skoleApi.get("razredi").then(response => {
                if (response.status === 200) {
                    this.rawClasses = response.data;
                    this.populateClasses();
                }
            })
        },
        methods: {
            populateClasses() {
                let self = this;
                this.rawClasses.forEach(function (type, index) {
                    type.forEach(function (item, index) {
                        if (!item.high_school && item.grade < 6) {
                            let obj = {};
                            obj["id"] = item.id;
                            obj["title"] = item.grade + '. Razred';
                            self.classes.push(obj);
                        }
                    })
                })
            },
            getVideos() {
                skoleApi.get('sadrzaji', {
                    params: {
                        'content_type': 6,
                        'search':  this.searchClient,
                        'content_date': this.selectedDate,
                        'school_class': this.classClient
                    }
                }).then(response => {
                    if (response.status === 200) {
                        this.loading = false;
                        this.videoList = response.data;
                    }
                }).catch(() => {
                    this.loading = false;
                })
            },
            playVideo(video) {
                this.$vuetify.goTo('#player');
                this.currentVideo = video;
            },
            handlePickedDate() {
                this.selectedDate = this.$moment(this.dateClient).format('D.M.YYYY');
                this.menu = false;
                this.getVideos();
            },
            handleSearchInput() {
                clearTimeout(this.search);
                this.search = setTimeout(()=> {
                    this.getVideos()
                }, 300)
            }
        }
    }
</script>
<style lang="scss" scoped>
    .sumtv {
        margin-top: 150px;
    }

    .alert {
        width: 90%;
    }

    .sumtv-content {
        background-color: #FFF;
    }

    .sumtv-iframe {
        width: 100%;
        min-height: 60vh;
    }

    .sum-placeholder {
        min-height: 60vh;
        background-color: #F0F5F7;
        border: 1px solid #DEE7EA;
        border-radius: 4px;
    }

    .placeholder-icon {
        color: #094776;
        opacity: 0.3;
    }

    .playlist-item {
        max-width: 100% !important;
    }

    @media (max-width: 768px) {
        .sumtv {
            margin-top: 120px !important;
        }
    }

    .videoteka {
        max-height: 64.5vh;
        overflow-y: scroll;
        width: 100% !important;
        overflow-x: hidden;
    }

    .videoteka-item {
        background-color: #fff;
        border: 1px solid #DEE7EA;
        min-height: 120px;
        cursor: pointer;
        border-radius: 4px;
        width: 90%;
    }

    .show-more {
        letter-spacing: 0 !important;
        width: 90%;
    }

    .vid-title {
        align-items: flex-start;
    }

    .mainplayer {
        max-width: 700px;
    }

    .carousel-nav {
        width: 300px;
        transform: rotate(90deg) translate(30px, -100%);
        transform-origin: left top;

        @media screen and (max-width: 1200px) {
            transform: rotate(90deg) translate(30px, -50%);
        }

        .carousel-cell {
            transform: rotate(-90deg);
            width: 80px;
            height: 80px;
            cursor: pointer;
            margin-right: 1rem;
            font-size: 1.4rem;

            /* selected cell */
            &.is-nav-selected {
                background: #ED2;
            }
        }

        .flickity-prev-next-button {
            width: 40px;
            height: 40px;
            background: transparent;

            &.previous {
                left: -40px;
            }

            &.next {
                right: -40px;
            }
        }
    }
</style>